<template>
  <div class="layout">
    <common-header></common-header>
    <router-view/>
    <common-footer></common-footer>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue'
import CommonFooter from '@/components/CommonFooter.vue'
export default {
  components: {
    'common-header': CommonHeader,
    'common-footer': CommonFooter,
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="stylus">

</style>